import { makeTheme } from '../theme/makeTheme';
export var makeDefaultTheme = function makeDefaultTheme() {
  return makeTheme();
};
export var makeLightTheme = makeDefaultTheme;